<app-panel-header-image-view pretitle="{{'Calendar' | transloco}}" title="{{'Competitions' | transloco}}" banner_image="../../../../../modules/custom/wa_angular/app/assets/images/banner.jpg">
</app-panel-header-image-view>

<app-app-content-page-wrapper>
  <app-featured-events></app-featured-events>
  <app-calendar-filters></app-calendar-filters>
  <app-calendar-list></app-calendar-list>
</app-app-content-page-wrapper>
